export const ONE_MIN = 60 * 1000
export const FIVE_MIN = 5 * ONE_MIN
